// extracted by mini-css-extract-plugin
export var quillEditor = "_n5-1";
export var variable = "_n5-0";